'use client'

import { type ComponentProps } from 'react'

import { AnchorTarget } from '@/components/common/AnchorTarget'

import { GalleryDisplayProvider } from './GalleryDisplayProvider/GalleryDisplayProvider'
import { GalleryGroupsProvider } from './GalleryGroupsProvider/GalleryGroupsProvider'
import { GalleryLayout } from './GalleryLayout/GalleryLayout'
import { GalleryPreloadProvider } from './GalleryPreloadProvider/GalleryPreloadProvider'

type Props = Partial<ComponentProps<typeof GalleryDisplayProvider>> &
  Partial<ComponentProps<typeof GalleryGroupsProvider>>

export const Gallery = (props: Props) => (
  <GalleryDisplayProvider {...props}>
    <GalleryPreloadProvider>
      <GalleryGroupsProvider recs={props.recs}>
        <AnchorTarget id='gallery' isSticky />
        <GalleryLayout />
      </GalleryGroupsProvider>
    </GalleryPreloadProvider>
  </GalleryDisplayProvider>
)
